// @flow
import { SHOW_SNACKBAR, HIDE_SNACKBAR } from '../constants/snackbar';

type ShowSnackbar = {
  type: typeof SHOW_SNACKBAR,
  payload: {
    message: string,
    type: string,
  },
};

type HideSnackbar = {
  type: typeof HIDE_SNACKBAR,
};

export type Actions = ShowSnackbar | HideSnackbar;

/**
 * @param {string} message
 * @param {string} type
 * @returns {{type: string}}
 */
export const showSnackbar = (message: string, type: string) => ({
  type: SHOW_SNACKBAR,
  payload: {
    message,
    type,
  },
});

/**
 * @returns {{type: string}}
 */
export const hideSnackbar = () => ({
  type: HIDE_SNACKBAR,
});
